import styled from 'styled-components';
import { palette } from 'styled-theme';
import { device } from '@jjj/components';

import WithDirection from '../../settings/withDirection';

const SidebarWrapper = styled.div`
  .isomorphicSidebar {
    /* Below the fixed topbar (z-index 1000 from the tablet breakpoint up, with the brand logo in its left
       corner), which this sticky sider, later in the DOM and padded for it, otherwise paints over. antd's modals
       and drawers stay at 1000, above the bar. */
    z-index: 999;
    background: ${palette('secondary', 0)};
    width: 240px !important;
    flex: 0 0 240px !important;
    user-select: none;
    position: sticky;
    top: 0;
    padding-top: 40px;

    @media ${device.tablet} {
      width: 280px;
      flex: 0 0 280px;
    }

    section {
      border-color: ${palette('grayscale', 3)};
      border-left-width: ${props => (props['data-rtl'] === 'rtl' ? '1px' : '0')};
      border-right-width: ${props => (props['data-rtl'] === 'rtl' ? '0' : '1px')};
      border-top-width: 0;
      border-bottom-width: 0;
      border-style: solid;
      height: auto;
    }

    .collapse-container {
      padding: ${props => (props['data-rtl'] === 'rtl' ? '10px 14px 10px 16px' : '10px 14px 10px 16px')};
      height: 56px;
      width: 100%;
      background-color: ${palette('grayscale', 5)};
      border-color: ${palette('grayscale', 3)};
      border-right-width: ${props => (props['data-rtl'] === 'rtl' ? '0' : '1px')};
      border-left-width: ${props => (props['data-rtl'] === 'rtl' ? '1px' : '0')};
      border-top-width: 0;
      border-bottom-width: 0;
      border-style: solid;
      cursor: pointer;
      visibility: visible;
      transition: all 0.2s, visibility 0s;
      display: flex;
      align-items: center;

      .fa-angle-double-left,
      .fa-angle-double-right {
        transform: rotate(${props => (props['data-rtl'] === 'rtl' ? '180' : '0')}deg);
      }

      .collapse-sidebar {
        align-items: center;
        color: ${palette('grayscale', 1)};
        display: flex;
        font-size: 14px;
        font-weight: 400;
        letter-spacing: 0.24px;
        line-height: 1.5;
        width: 100%;

        svg {
          font-size: 16px;
          width: 16px;
          color: ${palette('grayscale', 1)};
        }

        span {
          font-size: 14px;
          margin-left: ${props => (props['data-rtl'] === 'rtl' ? '0' : '16px')};
          margin-right: ${props => (props['data-rtl'] === 'rtl' ? '16px' : '0')};
          transition: opacity 0.2s;
          opacity: 1;
          white-space: nowrap;
        }
      }

      &.menuCollapsed {
        visibility: hidden;

        @media ${device.tablet} {
          visibility: visible;
          width: 48px;
          padding: 10px 0;
          justify-content: center;
        }

        .collapse-sidebar {
          justify-content: center;
        }

        span {
          opacity: 0;
          width: 0;
          margin: 0;
        }
      }
    }

    .scrollarea {
      height: calc(100vh - 120px);
    }

    &.ant-layout-sider-collapsed {
      width: 0;
      min-width: 0 !important;
      max-width: 0 !important;
      flex: 0 0 0 !important;

      @media ${device.tablet} {
        width: 48px;
        min-width: 48px !important;
        max-width: 48px !important;
        flex: 0 0 48px !important;
      }
    }

    section {
      background-color: ${palette('grayscale', 5)};
    }
  }
`;

export default WithDirection(SidebarWrapper);
